<template lang="pug">
  v-container(fluid)
    v-layout#dropdown.dropdown(row, wrap)
      v-flex.filter(xs2 offset-xs1)
        p Agresiones reportadas en:
          v-select(
            :items="cases"
            v-model="selectPlace"
            overflow
            label="Selecciona"
            target="#dropdown"
          )
      v-flex.filter(xs2)
        p Buscar palabras en las fichas:
          v-text-field.search.pa-0(append-icon="search"
            v-model="searchText"
            hide-details
            single-line
          )
      v-flex.filter(xs2)
        p Ordenar por:
          v-select(
            :items="cases"
            v-model="selectOrder"
            overflow
            label="Selecciona"
            target="#dropdown"
          )
      v-flex.filter(xs2)
        p Tipo de incidente:
          v-select(
            :items="cases"
            v-model="selectType"
            overflow
            label="Selecciona"
            target="#dropdown"
          )
    v-layout(row, wrap)
      //v-flex(sm5 xs10 offset-md1)
        v-card.postcard
          v-card-media(src="/static/logo.png" height="200px")
      v-flex(sm5 xs10 offset-md1)
        v-card.postcard
          v-layout(fluid, row, wrap)
            v-flex(xs3 text-xs-center)
              v-card-text.data Folio
              v-card-text.data Fecha
              v-card-actions
                v-btn.view(flat) VER POSTAL
              v-card-actions
                v-btn.view(flat) VER EN MAPA
            v-flex(xs9)
              v-card-title(primary-title)
                div.title
                  h3.headline.mb-0 Yucatán / Seyé
                  span  Tipo de incidente
              v-card-text.description El 22 de enero de 2018, el reportero Edwin Canché, del Diario de Yucatán,
                  | fue víctima de bloqueo informativo y amenazas por parte de particulares, cuando
                  | fue a cubrir un evento del candidato al gobierno estatal por parte del PAN,
                  | Mauricio Vila Dosal, y de la candidata al gobierno municipal de Seyé, Lizbeth
                  | Cauich Poch, el cual se realizó en el domicilio de ésta, en el mismo municipio
                  | de Seyé.
      v-flex(md5 sm10)
        v-card.postcard
          v-layout(fluid, row, wrap)
            v-flex(xs3 text-xs-center)
              v-card-text.data Folio
              v-card-text.data Fecha
              v-card-actions
                v-btn.view(flat) VER POSTAL
              v-card-actions
                v-btn.view(flat) VER EN MAPA
            v-flex(xs9)
              v-card-title(primary-title)
                div.title
                  h3.headline.mb-0 Yucatán / Seyé
                  span  Tipo de incidente
              v-card-text.description El 22 de enero de 2018, el reportero Edwin Canché, del Diario de Yucatán,
                  | fue víctima de bloqueo informativo y amenazas por parte de particulares, cuando
                  | fue a cubrir un evento del candidato al gobierno estatal por parte del PAN,
                  | Mauricio Vila Dosal, y de la candidata al gobierno municipal de Seyé, Lizbeth
                  | Cauich Poch, el cual se realizó en el domicilio de ésta, en el mismo municipio
                  | de Seyé.
</template>

<script>
export default {
  name: "PostCard",
  props: {},
  data() {
    return {
      selectPlace: "",
      searchText: "",
      selectOrder: "",
      selectType: "",
      cases: ["green", "blue", "red", "black"]
    };
  }
};
</script>
<style src="./postcard.scss" lang="scss">
</style>
